<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 27V5a2 2 0 00-2-2H9a2 2 0 00-2 2v22a2 2 0 002 2h14a2 2 0 002-2zM23 5v15h-.94l-2.69-5.38a1 1 0 00-.87-.55 1 1 0 00-.88.52L16 17.45l-3.17-5.95A1 1 0 0012 11a1 1 0 00-.88.45L9 14.6V5zM9 16.4l3-4.4 3.18 6a1 1 0 00.87.53 1 1 0 00.87-.51l1.6-2.87L20.94 20H9zM9 22h14v5H9z"/><path d="M20 10a2 2 0 10-2-2 2 2 0 002 2zm0-3a1 1 0 11-1 1 1 1 0 011-1z"/></svg>